export function classNames(...classes: any[]) {
    return classes.filter((className) => typeof className === "string" && className).join(" ");
}
